// extracted by mini-css-extract-plugin
export default {"techCard":"TechCard_techCard__iTJ+N","redefineContentlist":"TechCard_redefineContentlist__KPu0i","tickIcon":"TechCard_tickIcon__rGdS6"};